export const url = 'https://app.bidlight.com';
// export const url = "http://localhost:3300";
// export const curlightUrl = "https://curlight.com";
export const curlightUrl = "https://curlight.com";

// export const urlWS = 'wss://predeployment.bidlight.com';
//export const urlWS = 'ws://localhost';
export  const urlWS = 'wss://app.bidlight.com';


// export const url = "https://predeployment.bidlight.com"; //this one
//export const url = "http://localhost:3300";
export const IFC_Url = "https://ifc.bidlight.com"; // production url
// export const IFC_Url = "https://ifc.bidlight.com"; // production url
// export const IFC_Url = "http://localhost:4000"; // development local url

// Environment-scoped storage identity: production keys are
// "bidlight_*", the predeployment stack's are "prebidlight_*" — so the
// two sites never read each other's tokens in the same browser, and a
// glance at devtools says which environment a key belongs to.
const storagePrefix = url.includes('predeployment') ? 'prebidlight' : 'bidlight';
// One-time migration from the old host-derived keys (app_* / predeployment_*)
// so nobody gets logged out by the rename.
const legacyPrefix = url.split('//')[1].split('.')[0];
['token', 'user_permissions', 'company_permissions', 'all_permissions', 'coordination_only', 'primary_package'].forEach((k) => {
  try {
    const oldKey = `${legacyPrefix}_${k}`;
    const newKey = `${storagePrefix}_${k}`;
    if (!localStorage.getItem(newKey) && localStorage.getItem(oldKey)) {
      localStorage.setItem(newKey, localStorage.getItem(oldKey));
      localStorage.removeItem(oldKey);
    }
  } catch (e) { /* storage unavailable (SSR/private mode) — keys resolve empty */ }
});
export const tokenRef = `${storagePrefix}${"_"}${"token"}`;
export const user_permissionsRef = `${storagePrefix}${"_"}${"user_permissions"}`;
export const company_permissionsRef = `${storagePrefix}${"_"}${"company_permissions"}`;
export const all_permissionsRef = `${storagePrefix}${"_"}${"all_permissions"}`;
export const coordination_onlyRef = `${storagePrefix}${"_"}${"coordination_only"}`;
export const primary_packageRef = `${storagePrefix}${"_"}${"primary_package"}`;

export const defaultOptions = {
  headers: {
    "Content-Type": "application/json",
    "User-Agent": "Bidlight-Web-Deployment",

    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",

    Authorization: null,
  },
};

export const compressedOptions = {
  headers: {
    "Content-Type": "application/gzip",
    "content-encoding": "gzip",
    "User-Agent": "Bidlight-Web-Deployment",

    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Methods": "*",

    Authorization: null,
  },
};

// The backend answers 401 + X-Bidlight-Auth: company-suspended when the
// caller's company was suspended by a platform admin (or a Stripe pause)
// AFTER this token was issued. The token is otherwise valid, so nothing
// else would ever log the person out - drop the session here and send
// them to the login page, which explains why.
export const suspendedFlagRef = `${storagePrefix}${"_"}${"suspended"}`;
let _suspendRedirecting = false;
function suspendedSessionGate(res) {
  try {
    if (res.status !== 401) return;
    // Staging refuses a real person's session (back/utils/emailLinkRoutes):
    // drop it and open the same page on the real app.
    if (res.headers.get("X-Bidlight-Auth") === "staging-real-account") {
      if (_suspendRedirecting) return;
      _suspendRedirecting = true;
      [tokenRef, user_permissionsRef, company_permissionsRef, all_permissionsRef,
        coordination_onlyRef, primary_packageRef].forEach((k) => localStorage.removeItem(k));
      const q = String(window.location.search || "").replace(/^\?/, "").split(/[&?]/).filter((kv) => kv && !/^ml=/.test(kv)).join("&");
      window.location.replace(`https://app.bidlight.com${window.location.pathname}${q ? `?${q}` : ""}`);
      return;
    }
    // "login-paused": this one person's login was paused on Users and
    // permissions (back/utils/loginSuspension). Same drop, its own message.
    const why = res.headers.get("X-Bidlight-Auth");
    if (why !== "company-suspended" && why !== "login-paused") return;
    if (_suspendRedirecting) return;
    _suspendRedirecting = true;
    [tokenRef, user_permissionsRef, company_permissionsRef, all_permissionsRef,
      coordination_onlyRef, primary_packageRef].forEach((k) => localStorage.removeItem(k));
    sessionStorage.setItem(suspendedFlagRef, why === "login-paused" ? "paused" : "1");
    if (window.location.pathname !== "/" && window.location.pathname !== "/authorization") {
      window.location.assign("/");
    }
  } catch (e) { /* storage or window unavailable */ }
}

export function setJWT(token) {
  defaultOptions.headers.Authorization = "Bearer " + token;
  compressedOptions.headers.Authorization = "Bearer " + token;
}

export function post(endpoint, body, formData = false, isCurlight = false) {
  // console.log(defaultOptions.Authorization);
  // setJWT(localStorage.bidlight_token)
  const baseUrl = endpoint.startsWith("/ifc") ? IFC_Url : url;
  const formedUrl = isCurlight ? curlightUrl : baseUrl;
  return fetch(`${formedUrl}${endpoint}`, {
    method: "POST",
    body: formData ? body : JSON.stringify(body),
    headers: formData
      ? {
          Authorization: defaultOptions.headers.Authorization,
        }
      : defaultOptions.headers,
  }).then(async (res) => {
    suspendedSessionGate(res);
    if (!res.ok) {
      throw await res.json();
    }
    return await res.json();
  });
}

export function globalPut(endpoint, body, formData = false) {
  const baseUrl = endpoint.startsWith("/ifc") ? IFC_Url : url;
  return fetch(`${baseUrl}${endpoint}`, {
    method: "PUT",
    headers: formData
      ? {
          Authorization: defaultOptions.headers.Authorization,
        }
      : defaultOptions.headers,
    body: formData ? body : JSON.stringify(body),
  }).then(async (res) => {
    if (!res.ok) {
      throw await res.json();
    }
    return await res.json();
  });
}

export function get(endpoint, isCurlight = false) {
  const baseUrl = isCurlight ? curlightUrl : url;
  // Gzipped JSON assets are fetched bare (R2 serves them itself and the
  // extra headers only provoke a preflight) - but that test has to look
  // at the PATH, not the whole endpoint. An API call whose QUERY STRING
  // happens to end in a .json.gz path ("?manifestPath=uploads/x/
  // manifest.json.gz") was being sent without the Authorization header
  // and came back 401.
  const pathOnly = String(endpoint).split("?")[0];
  return fetch(`${baseUrl}${endpoint}`, {
    method: "GET",
    mode: "cors",
    headers: pathOnly.endsWith("json.gz") ? undefined : defaultOptions.headers,
  }).then(async (res) => {
    suspendedSessionGate(res);
    // An empty body (204, or a route that sent `null`) is not a JSON
    // error - resolve to null instead of throwing "Unexpected end of
    // JSON input" from a background fetch.
    const text = await res.text();
    if (!text || !text.trim()) return null;
    try {
      return JSON.parse(text);
    } catch (e) {
      // A BODY THAT IS NOT JSON MUST NOT BECOME A CHARACTER COMPLAINT.
      //
      // A 401 from this API is the bare word "Unauthorized", so JSON.parse
      // threw "Unexpected token 'U', \"Unauthorized\" is not valid JSON" -
      // which names a character and tells you nothing: not the status, not
      // the call, not that it was an auth problem at all. The owner's
      // 2026-10-04 log was full of it from crawler traffic on the public
      // /learning pages, where a visitor has no token.
      //
      // IT STILL THROWS, deliberately. Resolving to null for a 401 would
      // turn "you are not allowed" into "there is nothing", which is the
      // silent degradation we keep removing - a caller cannot tell those
      // apart and neither can a log.
      //
      // AND IT NAMES THE CALL, which is the part that matters for whoever
      // reads the next report: the thrown error carries the endpoint and the
      // status, so an unhandled rejection in a minified bundle identifies
      // ITSELF instead of needing a sourcemap. I could not pin the caller of
      // this one from the two bundle offsets alone - the next one will say.
      const short = text.trim().slice(0, 120);
      const err = new Error(`GET ${pathOnly} - ${res.status}${res.statusText ? ` ${res.statusText}` : ''}`
        + (short ? ` - ${short}` : ''));
      err.status = res.status;
      err.endpoint = pathOnly;
      err.body = text.slice(0, 500);
      err.notJson = true;
      throw err;
    }
  });
}

export function getWithoutURL(endpoint) {
  return fetch(`${endpoint}`, {
    method: "GET",
    mode: "cors",
    headers: endpoint.endsWith("json.gz") ? undefined : defaultOptions.headers,
  }).then(async (res) => {
    return await res.json();
  });
}
export function getCompressed(endpoint, isIfcProject) {
  const baseUrl = isIfcProject ? IFC_Url : url;
  return fetch(`${baseUrl}${endpoint}`, {
    method: "GET",
    mode: "cors",
    headers: endpoint.endsWith("json.gz")
      ? undefined
      : compressedOptions.headers,
  }).then(async (res) => {
    return await res.json();
  });
}

export function remove(endpoint, object, isCurlight = false) {
  const baseUrl = isCurlight ? curlightUrl : url;
  return fetch(`${baseUrl}${endpoint}`, {
    method: "DELETE",
    headers: defaultOptions.headers,
    body: JSON.stringify(object),
  }).then(async (res) => {
    return await res.json();
  });
}

export function putGeneral(endpoint, object) {
  return fetch(`${url}${endpoint}`, {
    method: "PUT",
    headers: defaultOptions.headers,
    body: JSON.stringify(object),
  }).then(async (res) => {
    return await res.json();
  });
}

export function put(id, body, formData) {
  return fetch(`${url}/timelines?id=${id}`, {
    method: "PUT",
    headers: !formData
      ? {
          Authorization: defaultOptions.headers.Authorization,
        }
      : defaultOptions.headers,
    body: !formData ? body : JSON.stringify(body),
  }).then(async (res) => {
    return await res.json();
  });
}

export function putCatalog(endpoint, object) {
  return fetch(`${curlightUrl}${endpoint}`, {
    method: "PUT",
    headers: defaultOptions.headers,
    body: JSON.stringify(object),
  }).then(async (res) => {
    return await res.json();
  });
}

export function putProject(id, body, formData) {
  return fetch(`${url}/projects?_id=${id}`, {
    //?_id=${id}
    method: "PUT",
    headers: !formData
      ? {
          Authorization: defaultOptions.headers.Authorization,
        }
      : defaultOptions.headers,
    body: !formData ? body : JSON.stringify(body),
  }).then(async (res) => {
    return await res.json();
  });
}

export function putUser(id, body, formData) {
  return fetch(`${url}/users`, {
    method: "PUT",
    body: JSON.stringify(body),
    headers: defaultOptions.headers,
  }).then(async (res) => {
    return await res.json();
  });
}

export function putMilestone(body) {
  return fetch(`${url}/milestones`, {
    method: "PUT",
    body: JSON.stringify(body),
    headers: defaultOptions.headers,
  }).then(async (res) => {
    return await res.json();
  });
}

export function removeBulkUsers(endpoint, object) {
  return fetch(`${url}${endpoint}`, {
    method: "DELETE",
    headers: defaultOptions.headers,
    body: JSON.stringify(object),
  }).then(async (res) => {
    console.log("res--------", res);
    return await res;
  });
}

export function removeBulkMile(endpoint, object) {
  return fetch(`${url}${endpoint}`, {
    method: "DELETE",
    headers: defaultOptions.headers,
    body: JSON.stringify(object),
  }).then(async (res) => {
    return await res.json();
  });
}

export function postpro(endpoint, body, formData = false) {
  // console.log(defaultOptions.Authorization);
  // setJWT(localStorage.bidlight_token)
  const baseUrl = url;
  return fetch(`${baseUrl}${endpoint}`, {
    method: "POST",
    body: formData ? body : JSON.stringify(body),
    headers: formData
      ? {
          Authorization: defaultOptions.headers.Authorization,
        }
      : defaultOptions.headers,
  }).then(async (res) => {
    if (!res.ok) {
      throw await res.json();
    }
    return await res.json();
  });
}

export function postCustomUrl(endpoint, body, formData = false) {
  return fetch(`${endpoint}`, {
    method: "PUT",
    timeout: 'infinte',
    body: formData ? body : JSON.stringify(body),
  }).then(async (res) => {
    if (!res.ok) {
      throw await res
    }
    return await res
  });
}
